var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 20.4V3.6C0.399902 1.6116 2.0115 0 3.9999 0H12.3999L19.5999 7.2V20.4C19.5999 22.3884 17.9883 24 15.9999 24H3.9999C2.0115 24 0.399902 22.3884 0.399902 20.4Z",
    fill: "#E72636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3999 4.8V0L19.5999 7.2H14.7999C13.4739 7.2 12.3999 6.126 12.3999 4.8Z",
    fill: "#FFA6AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2434 14.2572C7.2434 16.2228 5.6534 16.5756 5.0978 16.5756H4.397V18.4008C4.397 18.8424 4.0394 19.2 3.5978 19.2C3.1574 19.2 2.7998 18.8424 2.7998 18.402V12.9504C2.7998 12.4248 3.2246 12 3.749 12H5.0366C5.5766 12 7.2434 12.204 7.2434 14.2572ZM5.7182 14.2884C5.7182 13.4736 5.1386 13.3728 4.9142 13.3728H4.397V15.2544H4.9154C5.1386 15.2544 5.7182 15.102 5.7182 14.2884Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1152 15.6204C13.1152 18.348 11.656 19.2 10.1248 19.2H9.05076C8.52636 19.2 8.10156 18.7752 8.10156 18.2508V12.9504C8.10156 12.426 8.52636 12.0012 9.05076 12.0012H10.1248C11.7124 12 13.1152 12.894 13.1152 15.6204ZM11.4772 15.6204C11.4772 13.716 10.5376 13.4232 10.1452 13.4232H9.74796V17.7744H10.1452C10.5376 17.7756 11.4772 17.526 11.4772 15.6204Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6856 13.4652V14.9388H16.732C17.1028 14.9388 17.4028 15.2388 17.4028 15.6096V15.66C17.4028 16.0308 17.1028 16.3308 16.732 16.3308H15.6952V18.3756C15.6952 18.8304 15.3268 19.1988 14.872 19.1988C14.4172 19.1988 14.0488 18.8304 14.0488 18.3756V12.9492C14.0488 12.4248 14.4736 12 14.998 12H16.84C17.236 12 17.5576 12.3216 17.5576 12.7176V12.7488C17.5576 13.1448 17.236 13.4664 16.84 13.4664H15.6856V13.4652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.f8bb963c6d8cebb1b0fa6262dc170aa5.svg";
export { ForwardRef as ReactComponent };